// extracted by mini-css-extract-plugin
export default {"modalBodyScrollbar":"modalBodyScrollbar--NC1lr"};